import { getSession, setSession, getLocal, setLocal, switchTimeFormat, zeroPadding, toast, downLoadBase64Image, getReservationDate, getFileSuffix } from '../libs/utils'
import { logout } from '../api/user'
import { getSexText } from '../core/filter'
import { getReportPatientInfo } from '../api/report'
import { mapState, mapActions } from 'vuex'
import { uploadRelevantInformation, getCheckItemInfo, removeRelevantInfomation } from '../api/reservation'
import { getOnlineFilmViewUrl } from '../config'
import moment from 'moment'
import { base64ToBlob, fileToBase64, sleep } from './tool'
// 用户基本信息
const LoginUser = {
  computed: {
    // 用户信息
    userInfo () {
      return getSession('risUserInfo', 'object')
    },
    // 影像中心
    centerVos () {
      let data = getSession('userAuth', 'object') || {}
      return data.centerVos || []
    },
    // 上一次登录的信息
    lastCenter () {
      let data = getLocal('lastCenter', 'object') || null
      return data
    }
  },
  methods: {
    ...mapActions([
      'setCurrentCenter',
      'setUserInfo',
      'resetAppStateData'
    ]),
    async logoutHandle () {
      if (await logout()) {
        this.resetAppStateData()
        sessionStorage.clear()
        this.$router.replace({path: '/login'})
      }
    },
    // 设置APP数据
    setAppData (item) {
      let lastCenter = Object.assign({userId: this.userInfo.id, userName: this.userInfo.user_name}, item)
      setLocal('lastCenter', lastCenter)
      this.setCurrentCenter(lastCenter)
      this.setUserInfo(lastCenter)
    }
  }
}
// 选择影像中心
const SelectCenter = {
  data () {
    return {
      selectCenterId: '',// 选择的影像ID
      showSelectWorkPlace: false, //是否显示选择影像中心
    }
  },
  methods: {
    selectCenter () {
      let center = this.getSelectCenter()
      if (center) this.setCenter(center)
    },
    getSelectCenter () {
      let center = null
      for (let i = 0; i < this.centerVos.length; i++) {
        let item = this.centerVos[i]
        if (item.id === this.selectCenterId) {
          center = item
          break
        }
      }
      return center
    },
    setCenter (center) {
      this.setAppData(center)
      this.showSelectWorkPlace = false
      this.redirectWorkPlace()
    },
    redirectWorkPlace () {
      if (this.$route.name === 'home') {
        let userInfo  = getSession('userAuth', 'object')
        if (userInfo && userInfo.authMenus && userInfo.authMenus.length > 0) {
          return this.$router.replace({path: `/${userInfo.authMenus[0]['resources']}`})
        } else {
          toast({msg: '您没有使用改系统的权限，请联系管理员为您添加权限'})
          return this.$router.replace({name: 'login'})
        }
      }
    }
  }
}
// 影像报告
const Report = {
  data () {
    return {
      patientInfo: {},
      routeParams: {}
    }
  },
  methods: {
    async getPatientInfo (params) {
      let report = await getReportPatientInfo(params)
      if (report) {
        if (report.patientBirthDay) report.patientBirthDay = report.patientBirthDay.substring(0, 10)
        if (report.reportInfo.check_datetime) report.reportInfo.check_datetime = switchTimeFormat(report.reportInfo.check_datetime.substring(0, 10), 5)
        this.patientInfo = report
      }
    }
  },
  computed: {
    ...mapState({
      imageRepresentation: state => state.report.imageRepresentation,
      diagnosticResult: state => state.report.diagnosticResult,
      diseaseList: state => state.report.diseaseList,
      positiveNegative: state => state.report.positiveNegative,
      checkBody: state => state.report.checkBody,
      status: state => state.report.status
    }),
  }
}
// 拍摄相关资料
const RelevantInformation = {
  data () {
    return {
      relInformation: {
        generateLoading: false,
        openFlag: false,
        spinning: false,
        fileList: [],
        imagePreview: false,
        previewUrl: '',
        saveBtnLoading: false,
        checkOrderId: '', // 当前的检查ID
        photoTimer: null,
        openedCaramaFlag: false // 是否打开过高拍仪
      }
    }
  },
  computed: {
    ...mapState({
      caramaSocket: state => state.app.caramaSocket,
      caramaDialog: state => state.app.caramaDialog
    })
  },
  methods: {
    ...mapActions([
      'setOpenedCaramaFlag',
      'initTakePhotoSocket'
    ]),
    // 获取相关资料图片
    async getRelevantInfoData () {
      let list = await getCheckItemInfo({orderCheckId: this.relInformation.checkOrderId})
      if (list && list.length > 0) {
        list.forEach(item => {
          this.relInformation.fileList.push ({url: item})
        })
      }
    },
    async initRelevantInfoData () {
      if (this.relInformation.checkOrderId) {
        this.relInformation.fileList = []
        await this.getRelevantInfoData()
      }
    },
    // 拍摄资料
    async shootingMaterial (type) {
      if (type!== 'addCheck') {
        if (!this.selectItem.checkOrderId) return toast({msg: '请先选择预约项目'})
        this.relInformation.checkOrderId = this.selectItem.checkOrderId
        await this.initRelevantInfoData()
      }
      this.relInformation.openFlag = true
      this.relInformation.generateLoading = false
      if (this.openedCaramaFlag) return false
      if (!this.caramaSocket || !this.caramaDialog) {
        this.initTakePhotoSocket()
      }
      await sleep(1500)
      this.openCamaraWebSocket()
    },
    // 连接高拍仪的websocket
    openCamaraWebSocket () {
      this.caramaDialog.send_priImgData.connect(function (message){
        let element = document.getElementById("bigPriDev")
        if (element) element.src = "data:image/jpg;base64," + message
      })
      // 接受拍照
      this.caramaDialog.send_priPhotoData.connect((message)=> {
        let url = "data:image/jpg;base64," + message
        this.relInformation.fileList.push({url: url, baseCode: url})
        this.relInformation.generateLoading = false
        clearTimeout(this.relInformation.photoTimer)
        this.relInformation.photoTimer = null
      })
      this.initCamara()
    },
    // 初始化摄像头
    initCamara () {
      this.caramaDialog.html_loaded("one")
      this.openedCaramaFlag = true
    },
    // 拍照
    takePhoto () {
      if (!this.caramaSocket || !this.caramaDialog) return false
      if (this.relInformation.fileList.length >= 10) {
        toast({msg: '拍摄资料不能超过十张'})
        return false
      }
      if (this.relInformation.generateLoading || this.relInformation.photoTimer) return false
      this.relInformation.photoTimer = setTimeout(() => {
        this.relInformation.generateLoading = true
        this.caramaDialog.photoBtnClicked("primaryDev_")
        this.caramaDialog.get_actionType("savePhotoPriDev")
      }, 500)
    },
    closeRelInformation () {
      this.relInformation.saveBtnLoading = false
      this.relInformation.generateLoading = false
      this.relInformation.openFlag = false
    },
    // 上传相关资料
    async uploadRelInformation (type) {
      if (this.relInformation.fileList.length < 1) return toast({msg: '请先拍照要上传的文件'})
      if (this.relInformation.fileList.length > 10) return toast({msg: '拍摄资料不能超过十张'})
      if (type === 'addCheck') {
        return this.relInformation.openFlag = false
      } else {
        await this.uploadRelAction()
      }
    },
    async uploadRelAction (type) {
      // 新增检查
      if (type !== 'addCheck') this.relInformation.saveBtnLoading = true
      let i = 0
      for ( ; i < this.relInformation.fileList.length; i++) {
        let item = this.relInformation.fileList[i]
        if (!item.baseCode) continue
        let params = {orderCheckId: this.relInformation.checkOrderId, imageType: item.imageType || 'jpg'}
        if (item.file) params.image = item.file
        else params.image = base64ToBlob(item.baseCode)
        await uploadRelevantInformation(params)
      }
      if (i === this.relInformation.fileList.length) {
        if (type!== 'addCheck') toast({msg: '上传相关资料成功', title: '提示', type: 'success'})
        this.closeRelInformation()
        return true
      }
    },
    previewImage (item) {
      this.relInformation.previewUrl = item.url || item.baseCode
      this.relInformation.imagePreview = true
    },
    downLoadImage (item) {
      return downLoadBase64Image(`${new Date().valueOf()}.jpg`, item.url)
    },
    async deleteImage (item, index) {
      if (!item.baseCode) {
        let data = await removeRelevantInfomation({orderCheckId: this.relInformation.checkOrderId, urlPath: item.url})
        if (data) this.relInformation.fileList.splice(index, 1)
      } else {
        this.relInformation.fileList.splice(index, 1)
      }
    },
    async addImageBefore (file) {
      if (this.relInformation.fileList.length >= 10) {
        toast({msg: '拍摄资料不能超过十张'})
        return false
      }
      let fileType = getFileSuffix(file.name)
      fileType = fileType.toLowerCase()
      if (fileType !== 'png' && fileType !== 'jpg' && fileType !== 'jpeg' && fileType !== 'gif') {
        toast({msg: '只能上传图片文件'})
        return false
      }
      const fileImage = await fileToBase64(file)
      if (fileImage.base64) this.relInformation.fileList.push({ baseCode: fileImage.base64, file: file, url: fileImage.base64, imageType: fileType })
      return false
    }
  }
}
// 排队列表
const QueueList = {
  data () {
    return {
      queueDate: getReservationDate(),
    }
  },
  methods: {
    getLastDayTime () {
      this.queueDate = moment(this.queueDate).add(-1, 'd')
    },
    getNextDayTime () {
      this.queueDate = moment(this.queueDate).add(1, 'd')
    },
    selectQueueDate (date) {
      this.queueDate = getReservationDate(date)
    },
    formatData (arr) {
      for(let i = 0; i < arr.length; i++) {
        arr[i].timer = zeroPadding(arr[i].timer)
        arr[i].gender = getSexText(arr[i].gender)
      }
    },
    // 切换面板
    async changCheckCate (activeKey) {
      this.setCurDevice(activeKey)
      this.selectItem = {}
      this.static = {
        callNum: 0,
        todayCheckNum: 0,
      }
      await this.getQuenuList(activeKey)
      setSession('oldDeviceId', activeKey + this.$route.name)
    },
  },
  computed: {
    ...mapState({
      devices: state => state.app.devices || [],
      currentCenterId: state => state.app.currentCenterId,
      curDevice: state => state.app.curDevice
    }),
    defaultDeviceId () {
      if (this.curDevice) {
        return this.curDevice
      } else {
        this.setCurDevice(this.devices && this.devices[0] && this.devices[0]['id'])
        return this.devices && this.devices[0] && this.devices[0]['id']
      }
    }
  },
  watch: {
    async queueDate (oldVal, newVal) {
      if (switchTimeFormat(oldVal, 1) === switchTimeFormat(newVal, 1)) return false
      await this.initData()
    },
    async currentCenterId (newVal, oldVal) {
      if (newVal === oldVal || !newVal) return false
      await this.initData()
    }
  }
}
// 打开 Unimed-KOsirix
const WatchImageByWeasisOrOsrix = {
  methods: {
    async getReportInfos (params) {
      let report = await getReportPatientInfo(params)
      if (report) {
        return report
      }
      return {}
    },
    async openWeasis  (data, type) {
      if (type === 'history') {
        if (!data.weasis_url) return toast({msg: '传入weasis地址错误'})
        return window.location.href = "weasis://" + encodeURIComponent(`$dicom:get -w ${data.weasis_url}`)
      } else if (!type) {
        let report = await this.getReportInfos({id: data.reportInfo.id})
        if (!report.reportInfo || !report.reportInfo.matched_film_no) return toast({ msg: '暂无影像查看，请耐心等待技师上传影像' })
        if (report.weasis_url) return window.location.href = "weasis://" + encodeURIComponent(`$dicom:get -w ${report.weasis_url}`)
        return toast({msg: '传入weasis地址错误'})
      } else {
        return toast({msg: '传入weasis地址错误'})
      }
    },
    async openOsirix (data, type) {
      if (type === 'history') {
        if (!data.osirix_url) return toast({msg: '传入Osirix地址错误'})
        return window.location.href = `osirix://?methodName=downloadURL&Display=YES&URL=${data.osirix_url}`
      } else if (!type) {
        let report = await this.getReportInfos({id: data.reportInfo.id})
        if (report) {
          if (report.reportInfo && !report.reportInfo.matched_film_no) return toast({ msg: '暂无影像查看，请耐心等待技师上传影像' })
          if (!report.osirix_url) return toast({msg: '传入Osirix地址错误'})
          return window.location.href = `osirix://?methodName=downloadURL&Display=YES&URL=${report.osirix_url}`
        } else {
          return toast({msg: '传入Osirix地址错误'})
        }
      } else {
        return toast({msg: '传入Osirix地址错误'})
      }
    },
    async openFilmView (params) {
      let filmNo = ''
      if (params.filmNo) {
        filmNo = params.filmNo
      } else {
        if (!params || !params.reportInfo || !params.reportInfo.id) return toast({msg: '传入参数错误'})
        let report = await this.getReportInfos({id: params.reportInfo.id || params.orderId})
        if (!report || !report.reportInfo || !report.reportInfo.matched_film_no) return toast({ msg: '暂无影像查看，请耐心等待技师上传影像' })
        filmNo = report.reportInfo.matched_film_no
      }
      let openFilmUrl = getOnlineFilmViewUrl()
      const endStamp = moment().add(30, 'day').valueOf()
      openFilmUrl = openFilmUrl + '?filmNo='+window.btoa(filmNo) + '&end=' + window.btoa(String(endStamp))
      return window.open(openFilmUrl, '_blank')
    }
  }
}
// 处理表格表头固定
const fixTableHeader = {
  data () {
    return {
      tableDom: null,
      fixTableHeaderTimer: null
    }
  },
  methods: {
    handleTableScroll (selectorName) {
      this.tableDom = document.querySelector(selectorName)
      if(this.tableDom) this.tableDom.addEventListener('scroll', this.fixTableHeader, true)
    },
    fixTableHeader (e) {
      if (this.fixTableHeaderTimer) return false
      this.fixTableHeaderTimer = setTimeout(() => {
        e.preventDefault()
        this.tableDom.querySelector('thead').style.transform = 'translateY(' + e.srcElement.scrollTop + 'px)'
        this.fixTableHeaderTimer = null
      }, 500)
    },
    removeHandleListener() {
      if (this.tableDom) this.tableDom.removeEventListener('scroll', (event) => {
        event.preventDefault()
      })
    }
  }
}

export { LoginUser, SelectCenter, Report, RelevantInformation, QueueList, WatchImageByWeasisOrOsrix, fixTableHeader }